<template>
    <ShowControl  :title="title" ref="showControl" @revert="revertClick"> 
        <v-md-preview  :text="content" />
   </ShowControl>
</template>
    <script>
  import ShowControl from "../../UserControl/ShowControl.vue"
  export default {
    components: { ShowControl },
    data () {
      return {
        title: '评分规则',
        content: ''
      };
    },
    created () {
      
    },
    mounted(){
      this.$refs.showControl.receiveValue(true);
    },
    methods: {
        revertClick(){
          this.$router.go(-1)
        },
    },
  };
    </script>
    
    <style scoped>
  </style>